"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const ArrowReverse = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 8,
  height: 14,
  viewBox: "0 0 8 14",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("g", {
  clipPath: "url(#clip0_68_11923)"
}, /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.586 7L.293 1.707A1 1 0 011.707.293l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L5.586 7z",
  fill: "#fff"
})), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
  id: "clip0_68_11923"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: "#fff",
  d: "M0 0h8v14H0z"
}))));
var _default = exports.default = ArrowReverse;